<template>
  <div class="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 mt-5 mb-5">
    <Card
        v-for="(game, index) in 8"
        img="/src/assets/images/all-img/loading.jpg"
        imaClass="rounded-md"
        overlay
        titleClass="2xl:pb-14"
        noborder
        body-class="m-0"
        className="ratio ratio-16x9 rounded-lg"
    >
      <div
          class="m-0 cursor-pointer text-slate-900 dark:text-white text-4xl h-full flex justify-center items-center">
        <Button
            text="&nbsp"
            link="#"
            btnClass="btn rounded-b-lg rounded-t-none w-full bottom-0 absolute p-2 text-white bg-black-500/50"
            icon="iconamoon:check-bold"
            iconPosition="right"
            iconClass="hidden"
        >
        </Button>

        <div class="animate-pulse rounded-circile p-2 bg-black-500/50 dark:text-white text-white">
          <Icon icon="solar:gamepad-broken"/>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/Card/index.vue";
import Button from "@/components/Button/index.vue";
import {Icon} from "@iconify/vue";

export default {
  components: {
    Card,
    Button,
    Icon
  },
}
</script>

<style scoped lang="scss">

</style>